import { GET_WEST_LIST_DATA } from "./actionType";

const defaultState = {
  all: {},//全部
  other: {},//其他
  assay: {},//化验
  examination: {},//体检
};
const Reducer = (state = defaultState, action) => {
  switch (action.type) {
    case GET_WEST_LIST_DATA://存
      const list = JSON.parse (JSON.stringify (action.list));
      if (list.page === 1) {
        return { ...state, ...action.list };
      } else {
        switch (list.type) {
          case 0:
            return returnState (state, list, "all");
          case 1:
            return returnState (state, list, "examination");
          case 2:
            return returnState (state, list, "assay");
          case 3:
            return returnState (state, list, "other");
          default:
            return { ...state, ...action.list };
        }
      }
    default:
      return state;
  }
};
const returnState = (state, list, key) => {
  const newState = JSON.parse (JSON.stringify (state));
  newState[key].current_page = list[key].current_page;
  newState[key].total_page = list[key].total_page;
  newState[key].total = list[key].total;
  newState[key].list = newState[key].list ?
    [
      ...JSON.parse (JSON.stringify (newState[key].list)),
      ...JSON.parse (JSON.stringify (list[key].list))
    ]
    : list[key].list;
  return newState;
};
export default Reducer;
